export default {
  session: {
    img: 'https://web-data.zmlearn.com/image/pWxqA1SZMU8xvkCZLgKFUk/img_banner_text%402x.png',
    button: 'https://web-data.zmlearn.com/image/nn4obHxm4TCe2rK8VmXck3/%E7%BC%96%E7%BB%84%208%402x.png'
  },
  howMuch: {
    title: '<h1>How much does<span> AirClass </span>online tutoring cost?</h1>',
    desc: 'The price of tutoring is affordable and reasonable, depending on the type and duration of the learning plan. For example, the cost of Physics tutoring will be lower if you purchase a package with several lessons included. '
  },
  onlyPay: {
    title: `<h1>You’ll  <span> only pay</span> for<p>  what you use</p></h1>`,
    title1: `<h1>Always <span>flexible</span> and<p>&nbsp;reliable</p></h1>`,
    desc: 'With AirClass, you won’t pay anything until you decide to continue to having our formal tutoring after trial lesson. No sign up fees.'
  },
  risk: {
    title: `<h1>Completely <span> risk-free</span></h1>`,
    list: [
      {
        id: 1,
        title: 'Quality Control',
        content: 'All tutors go through an admission procedure and training.',
        backgroundColor: '#FF8395',
        icon: ['#32C095', '#FFC452'],
        img: 'https://web-data.zmlearn.com/image/aTnazj4xbyw5xzJ4iMmQJX/icon_home_part7_pink%402x.png'

      },
      {
        id: 2,
        title: 'Replacement Tutor',
        content: 'We always find a suitable replacement in the shortest possible time.',
        backgroundColor: '#70B2FA',
        icon: ['#FF8395', '#FFC452'],
        img: 'https://web-data.zmlearn.com/image/weC7D4eHds6pH2Dv5E5hE8/icon_home_part7_green%402x.png'
      },
      {
        id: 3,
        title: 'Payment and Refund',
        content: 'All common payment methods are available and refund available within 14 days of payment.',
        backgroundColor: '#2EC89A',
        icon: ['#48B4FF', '#FF8395'],
        img: 'https://web-data.zmlearn.com/image/eFdK7FvHvCnGJGkPxj36Rt/icon_home_part7_yellow%402x.png'
      },
      {
        id: 4,
        title: 'Security',
        content: 'All data and personal information is 100% secure with us.',
        backgroundColor: '#FFC452',
        icon: ['#32C095'],
        img: 'https://web-data.zmlearn.com/image/2YNrSHMR3gY8V7HDczyZcn/icon_home_part7_blue%402x.png'
      }
    ]
  },

  comments: {
    title: `<h1><p>Highly</p><span>&nbsp;Recommended&nbsp;</span>by our parents and students</h1>`,
    excellent: 'Excellent',
    reviews: 'Based on 2,809 reviews',
    list: [
      {
        id: 1,
        name: `Gracie Morley`,
        date: 'Jan 09, 2022',
        content: `My child finds maths very difficult yet I find she grasps concept with Simon very quickly.Im very happy with how much she has learnt in such a short period of time. Great maths tutor!`
      },
      {
        id: 2,
        name: `Joanne Fogarty`,
        date: 'Jan 15, 2022',
        content: `Guy is a very hardworker, devoted teacher and too assistant to our son. Hededicated to his work. So we are very happy with that teacher.`
      },
      {
        id: 3,
        name: `Carole Turner`,
        date: 'Jan 14, 2022',
        content: `to be honest all the tutors teach my kids have been brilliant, form been patient to communicating with my kids they have been amazing and I can always get in touch with them if need be.`
      }, {
        id: 4,
        name: `Sarah Houston`,
        date: 'Jan 9, 2022',
        content: `My son started physics with his tutor Alison a month ago. I can tell you that I am happy about this decision as Alison. He has already better scores at physics tests at school. Alison is very helpful even outside tuition session and very patient! Recommend her to you all!`
      },
      {
        id: 5,
        name: `Pam Brown`,
        date: 'Jan 7, 2022',
        content: `Ellie is an excellent tutor who is friendly and approachable. My son's interest and confidence increased. His A Level Psychology has greatly improved and he has begun to believe that he can achieve his target grade. I highly recommend Ellie as a Psychology tutor.`
      },
      {
        id: 6,
        name: `Tara Holmes`,
        date: 'Dec 19, 2021',
        content: `My tutor from AirClass managed to save my maths skills in less than a month. Definitely an excellent tutoring website, I would recommend it to anyone willing to invest some time and money into improving their future (especially for university)`
      }
    ]
  },
  faqs: {
    title: `<h1><span>FAQs</span>  about tutoring costs and others</h1>`,
    q: 'Q',
    list: [
      {
        question: 'How AirClass tutoring works?',
        answer: `Step 1: Initial assessment <br/>
				During the first call, we will define the student's needs and choose the ideal tutor for them based on qualifications, personality and the student's requirements. <br/>
				Step 2: Free trial lesson <br/>
				In a trial lesson, you can get to know AirClass without any obligations. The tutor will assess the initial situation and develop a personal learning plan together with you. You can also make more specific requests for future courses through the trial lesson. <br/>
				Step 3: Goal setting <br/>
				In this phase, we will define the student's goals and figure out the best way to achieve them together. <br/>
				Step 4: Start Our 1-on-1 online Tutoring <br/>
				Once you've started your course, our course consultant will help you to settle everything you need. You can ask your course consultant to help you schedule your lesson, change lesson times, cancel lessons or any other needs.
				`
      },
      {
        question: 'Can I exchange my tutor?',
        answer: 'If a tutor is not suitable for your step or any other organisational reasons, you are able to change tutors without any problems.'
      },
      {
        question: 'What payment options are available?',
        answer: 'You can pay for tutoring easily using all credit and debit cards, PayPal, Google Pay, Stripe, AllinPay and Alipay.'
      }
    ]
  }
};
